import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "pagosItinerarios",
    "pagosItinerarios",
    "pagosItinerariosform",
    "/pagos_itinerario",
);

export default handleActions(reducers, initialState);
